/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { Script } from "gatsby";
import Seo from "./seo";
import { MainFooter } from "./footer";
import NavBar from "./navbar";
import { Subfooter } from "./subfooter";

const Layout = ({ children, description, title, ignoreSiteName = false, defaultStyle = true }) => {
  const noOfChildren = children.length;
  return (
    <>
    <Script  id="snippet">
    {`
      !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "20eb374f-3c0a-4a34-88bd-f89d9b4bf140"}});
      AF('banners', 'showBanner')
    `}

</Script>
      <Seo title={title} description={description} ignoreSiteName={ignoreSiteName} />
      <NavBar />
      {/* All children except the last child */}
      <main>{children.slice(0, noOfChildren - 1)}</main>

      {/*Show the last item in the subfooter */}
      <Subfooter>{children[noOfChildren - 1]}</Subfooter>
      <MainFooter defaultStyle={defaultStyle} />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
};

export default Layout;
